import { Select, Form } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import mask from '../../../../../utils/mask';
import { Props } from './props';
import { TextLabel } from 'components/TextLabel';

const Fornecedor: React.FC<Props> = ({ setCodFornecedor, setNomeFornecedor }) => {
  const fornecedor = useSelector((state: ApplicationState) => state.Fornecedor.data);
  const { Option } = Select;

  const handleChange = (value: string, e: any) => {
    setCodFornecedor(Number(e.key));
    setNomeFornecedor(value);
  };

  return (
    <Form.Item
      name="nomeFornecedor"
      label={<TextLabel>Fornecedor</TextLabel>}
      rules={[{ required: true, message: 'Por favor preencha este campo!' }]}
    >
      <Select
        filterOption={(inputValue, element) =>
          element?.children.toString().toLowerCase().includes(inputValue.toLowerCase())
        }
        showSearch
        onChange={handleChange}
      >
        {fornecedor.map((item: any) => (
          <Option key={item.codParc} value={item.nome}>
            {item.nome}
            <br />
            {item.cnpjCpf ? mask('cpfCnpj', item.cnpjCpf) : ''}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default Fornecedor;
